import { render, staticRenderFns } from "./ModalBiblioteca.vue?vue&type=template&id=4b0360ea&scoped=true"
import script from "./ModalBiblioteca.vue?vue&type=script&lang=js"
export * from "./ModalBiblioteca.vue?vue&type=script&lang=js"
import style0 from "./ModalBiblioteca.vue?vue&type=style&index=0&id=4b0360ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0360ea",
  null
  
)

export default component.exports